import { useEffect, useState } from "react";
import { Download, FileText, Loader2 } from "lucide-react";
import { api } from "../../connect/api";

const fmt = (n) => (n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
const cache = new Map();

/** Renders a photo (inline preview, tap to open) or a PDF card; files are fetched with the auth token and shown via object URLs. */
export const Attachment = ({ att, caption, mine }) => {
  const [url, setUrl] = useState(cache.get(att.path) || "");
  const [busy, setBusy] = useState(false);
  const fetchBlob = async () => {
    if (cache.get(att.path)) return cache.get(att.path);
    setBusy(true);
    try {
      const { data } = await api.get(`/files/${att.path}`, { responseType: "blob" });
      const u = URL.createObjectURL(data); cache.set(att.path, u); setUrl(u); return u;
    } finally { setBusy(false); }
  };
  useEffect(() => { if (att.kind === "image" && !url) fetchBlob().catch(() => {}); }, [att.path]); // eslint-disable-line react-hooks/exhaustive-deps
  const open = async () => { const u = await fetchBlob(); window.open(u, "_blank", "noopener"); };
  const showCaption = caption && !caption.startsWith("📷") && !caption.startsWith("📄");
  return (
    <div data-testid="attachment">
      {att.kind === "image" ? (
        <button type="button" onClick={open} className="block rounded-xl overflow-hidden -mx-1 -mt-0.5 mb-1 bg-black/20 min-w-[160px] min-h-[100px]" data-testid="attachment-image">
          {url ? <img src={url} alt={att.name} className="max-h-64 w-full object-cover" /> : <div className="flex items-center justify-center h-[100px]"><Loader2 size={18} className="animate-spin opacity-70" /></div>}
        </button>
      ) : (
        <button type="button" onClick={open} className={`flex items-center gap-2.5 rounded-xl px-2.5 py-2 mb-1 text-left ${mine ? "bg-white/15" : "bg-white/5"}`} data-testid="attachment-pdf">
          <span className="w-9 h-9 rounded-lg bg-red-500/20 text-red-300 flex items-center justify-center shrink-0"><FileText size={18} /></span>
          <span className="min-w-0"><span className="block text-sm font-medium truncate max-w-[180px]">{att.name}</span><span className="block text-[10px] opacity-70">PDF · {fmt(att.size)}</span></span>
          {busy ? <Loader2 size={14} className="animate-spin ml-1" /> : <Download size={14} className="ml-1 opacity-70" />}
        </button>
      )}
      {showCaption && <div>{caption}</div>}
    </div>
  );
};
